import { get as idbGet, set as idbSet, del as idbDel } from 'idb-keyval';

const LOG_KEY = 'logs:buffer';
const MAX_BYTES = 5 * 1024 * 1024; // 5 MB cap

let inMemory = [];
let inMemoryBytes = 0;
let loaded = false;

const sizeOf = (entry) => {
  try { return JSON.stringify(entry).length; } catch { return 0; }
};

const trim = () => {
  while (inMemoryBytes > MAX_BYTES && inMemory.length > 0) {
    inMemoryBytes -= sizeOf(inMemory[0]);
    inMemory.shift();
  }
};

const persist = () => {
  idbSet(LOG_KEY, inMemory).catch(() => {});
};

const loadOnce = async () => {
  if (loaded) return;
  loaded = true;
  try {
    const persisted = await idbGet(LOG_KEY);
    if (Array.isArray(persisted)) {
      inMemory = persisted;
      inMemoryBytes = persisted.reduce((n, e) => n + sizeOf(e), 0);
      trim();
    }
  } catch {
    /* indexeddb disabled */
  }
};

export const flushLogs = (entries) => {
  if (!Array.isArray(entries) || entries.length === 0) return;
  for (const e of entries) {
    inMemory.push(e);
    inMemoryBytes += sizeOf(e);
  }
  trim();
  persist();
};

export const getPersistedLogs = async () => {
  await loadOnce();
  return inMemory.slice();
};

export const clearPersistedLogs = async () => {
  inMemory = [];
  inMemoryBytes = 0;
  try { await idbDel(LOG_KEY); } catch { /* ignore */ }
};
